export const getThemeEventSelectorId = id => `marketplace-mirrored__theme__${id}`;